import isArray from './isArray'

interface IEach {
	<T>(arr : T[],cb : (value : T, i : number, arr : T[])=> void | false) : void
	(arr : number,cb : (value : number, i : number, arr : number)=> void | false) : void
}


const  each = (<T>(arr : T[] | number,cb : (value : T | number, i : number, arr : T[] | number)=> void | false)=>{
	let isArr = isArray(arr)
	if (!isArr && typeof arr !== 'number') {
		throw new TypeError('The first parameter must be array or number')
	}
	if (typeof cb !== 'function') {
		throw new TypeError('The second parameter must be function')
	}

	var len = isArr ? (arr as T[]).length : arr
	for (var i = 0; i < len; i++) {
		var value = isArr ? (arr as T[])[i] : i + 1
		if(cb.call(arr,value,i,arr) === false){
			break
		}
	}
}) as IEach

export default each